module.exports = __webpack_public_path__ + "img/55.c4c3a15c.png";